import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';

// Ported 1:1 from the prototype `.card` / `.card-head` / `.card-pad`.
export const styles = {
  card: {
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "x7tdnnd",
    $$css: true
  },
  head: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "x1qughib",
    kOIVth: "x1mnnc3i",
    k8WAf4: "x17nk906",
    kg3NbH: "xytz8ft",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xra1o3",
    $$css: true
  },
  title: {
    kMv6JI: "xpc6l4x",
    kGuDYH: "x14k033y",
    k63SB2: "xomqrzn",
    kMwMTN: "x1oezkus",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  sub: {
    kGuDYH: "x34ze3o",
    kMwMTN: "xdxw5r1",
    keoZOQ: "xvijh9v",
    $$css: true
  },
  paddingNone: {
    kmVPX3: "x1717udv",
    $$css: true
  },
  paddingMd: {
    kmVPX3: "x1bn5kwv",
    $$css: true
  }
};